import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-the-l04-pagination" }
const _hoisted_2 = { class: "p-the-l04-pagination__item" }
const _hoisted_3 = ["href"]
const _hoisted_4 = {
  class: "p-the-l04-pagination__item__text",
  "data-translate-skip": ""
}
const _hoisted_5 = { class: "p-the-l04-pagination__item" }
const _hoisted_6 = ["href"]
const _hoisted_7 = {
  class: "p-the-l04-pagination__item__textright",
  "data-translate-skip": ""
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconArrowLeft40px = _resolveComponent("IconArrowLeft40px")!
  const _component_IconBase = _resolveComponent("IconBase")!
  const _component_IconArrowRight40px = _resolveComponent("IconArrowRight40px")!
  const _directive_touch = _resolveDirective("touch")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.prevTitle)
        ? _withDirectives((_openBlock(), _createElementBlock("a", {
            key: 0,
            href: _ctx.prevLink,
            class: "p-the-l04-pagination__item__link"
          }, [
            _createVNode(_component_IconBase, {
              width: "40",
              height: "40",
              "view-box": "0 0 40 40",
              "icon-color": "#000000"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_IconArrowLeft40px)
              ]),
              _: 1
            }),
            _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.prevTitle), 1)
          ], 8, _hoisted_3)), [
            [_directive_touch, void 0, "tap"]
          ])
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_ctx.nextTitle)
        ? _withDirectives((_openBlock(), _createElementBlock("a", {
            key: 0,
            href: _ctx.nextLink,
            class: "p-the-l04-pagination__item__link p-the-l04-pagination__item__link--next"
          }, [
            _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.nextTitle), 1),
            _createVNode(_component_IconBase, {
              width: "40",
              height: "40",
              "view-box": "0 0 40 40",
              "icon-color": "#000000"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_IconArrowRight40px)
              ]),
              _: 1
            })
          ], 8, _hoisted_6)), [
            [_directive_touch, void 0, "tap"]
          ])
        : _createCommentVNode("", true)
    ])
  ]))
}